import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0be0b5",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function SimpleTable({ data, clientData, ledgerData }) {
  // console.log(ledgerData)
  const convertDate = (dates) => {
    const seconds = dates; // Assuming the value is in seconds
    const milliseconds = seconds * 1000; // Convert seconds to milliseconds
    const date = moment(milliseconds);

    return date.format("DD-MM-YYYY");
  };
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="left">Date</StyledTableCell>
            <StyledTableCell align="left">Details</StyledTableCell>
            <StyledTableCell align="left">Payment</StyledTableCell>
            <StyledTableCell align="left">Purchase</StyledTableCell>
            <StyledTableCell align="left">Balance</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ledgerData?.map((row) => (
            <StyledTableRow key={1}>
              <StyledTableCell align="left">
                {row.date ? moment(row.date).format("DD-MM-YYYY") : "-"}
              </StyledTableCell>
              <StyledTableCell align="left">
                {`${row.details}`}
              </StyledTableCell>
              <StyledTableCell align="left">
                {row.debit}
              </StyledTableCell>
              <StyledTableCell align="left">{`${
                row.credit
              }`}</StyledTableCell>
              <StyledTableCell align="left">
                {row.closing}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
